module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/3/4-30e1de75d193f31ff994d3108a47f295.jpg";